var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type, Transform } from 'class-transformer';
import { SeverityLevel, EventStatus, SiemEventType, SiemEventSource, EventModelGroupingType } from '@logz-pkg/enums';
let EventModel = class EventModel {
    id;
    /** The triggered alert the event came from; absent for an event that did not come from a rule (source Agent). */
    alertEventId;
    /** The rule the event came from; absent for an event that did not come from a rule (source Agent). */
    alertDefinitionId;
    status;
    assignee;
    comment;
    commentedBy;
    title;
    description;
    severity;
    triggeredAt;
    lastTriggeredAt;
    updatedAt;
    updatedBy;
    count;
    riskScore;
    mitreTags = [];
    type;
    /** Absent in the API for events that came from a rule; an agent event has no rule id and no triggered alert. */
    source;
    groupingType;
};
__decorate([
    Expose(),
    __metadata("design:type", String)
], EventModel.prototype, "id", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "alertEventId", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Number)
], EventModel.prototype, "alertDefinitionId", void 0);
__decorate([
    Expose(),
    Transform(status => (status || EventStatus.New), { toClassOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], EventModel.prototype, "assignee", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EventModel.prototype, "comment", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object)
], EventModel.prototype, "commentedBy", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "title", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "description", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Transform(severity => severity, { toClassOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "severity", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Type(() => Date),
    Transform(value => value * 1000, { toClassOnly: true }),
    __metadata("design:type", Date)
], EventModel.prototype, "triggeredAt", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Type(() => Date),
    Transform(value => (value ? value * 1000 : null), { toClassOnly: true }),
    __metadata("design:type", Date)
], EventModel.prototype, "lastTriggeredAt", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Type(() => Date),
    Transform(value => (value ? value * 1000 : null), { toClassOnly: true }),
    __metadata("design:type", Date)
], EventModel.prototype, "updatedAt", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object)
], EventModel.prototype, "updatedBy", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Number)
], EventModel.prototype, "count", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Number)
], EventModel.prototype, "riskScore", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Array)
], EventModel.prototype, "mitreTags", void 0);
__decorate([
    Exclude({ toPlainOnly: true }),
    __metadata("design:type", String)
], EventModel.prototype, "type", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Transform(value => value ?? SiemEventSource.Rule),
    __metadata("design:type", String)
], EventModel.prototype, "source", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    Transform(value => value ?? EventModelGroupingType.AlertBased),
    __metadata("design:type", String)
], EventModel.prototype, "groupingType", void 0);
EventModel = __decorate([
    Exclude()
], EventModel);
export { EventModel };
//# sourceMappingURL=event.js.map